module.exports = "https://coursera_assets.s3.amazonaws.com/images/2fe47744cde1a0e41e409bf488e98027.png";